define(["./mapsModule", "../arrays/arrays", "../colors/colors"], function (mapsModule, arrays, colors) {
    "use strict";

    /**
     * @ngdoc service
     * @name mapsModule.mapsDirectionsService
     * @description
     * Serviço que recebe um array de rotas e retorna uma promessa que será resolvida quando todas as rotas terminarem
     * de ser geocodificadas.
     * **Atenção:** Serão adicionadas propriedades nas rotas.
     * */
    return mapsModule.service("mapsDirectionsService", ["$q", "$timeout", "mapsPathService", function ($q, $timeout, _mapsPathService) {

        return function (routes) {
            var mapsPathService = _mapsPathService;
            arrays.each(routes, function (route, routeIndex) {
                route.color = route.color || getRouteColor(routeIndex);
                route.visible = true;
            });

            return $q.all(arrays.map(routes, function (route) {
                return mapsPathService(route);
            })).then(function () {
                return routes;
            });
        };
    }]);

    function getRouteColor(routeIndex) {
        return colors.getColor(routeIndex);
    }
});